import _classCallCheck from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
/**
 * @license
 * Copyright 2022 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
import { Layer } from '../../engine/topology';
import { serialization, tidy } from '@tensorflow/tfjs-core';
import { greater, greaterEqual, max, min } from '@tensorflow/tfjs-core';
import { getExactlyOneShape, getExactlyOneTensor } from '../../utils/types_utils';
import { ValueError } from '../../errors';
import * as K from '../../backend/tfjs_backend';
import * as utils from './preprocessing_utils';
var CategoryEncoding = /*#__PURE__*/function (_Layer) {
  _inherits(CategoryEncoding, _Layer);
  function CategoryEncoding(args) {
    var _this;
    _classCallCheck(this, CategoryEncoding);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(CategoryEncoding).call(this, args));
    _this.numTokens = args.numTokens;
    if (args.outputMode) {
      _this.outputMode = args.outputMode;
    } else {
      _this.outputMode = 'multiHot';
    }
    return _this;
  }
  _createClass(CategoryEncoding, [{
    key: "getConfig",
    value: function getConfig() {
      var config = {
        'numTokens': this.numTokens,
        'outputMode': this.outputMode
      };
      var baseConfig = _get(_getPrototypeOf(CategoryEncoding.prototype), "getConfig", this).call(this);
      Object.assign(config, baseConfig);
      return config;
    }
  }, {
    key: "computeOutputShape",
    value: function computeOutputShape(inputShape) {
      inputShape = getExactlyOneShape(inputShape);
      if (inputShape == null) {
        return [this.numTokens];
      }
      if (this.outputMode === 'oneHot' && inputShape[inputShape.length - 1] !== 1) {
        inputShape.push(this.numTokens);
        return inputShape;
      }
      inputShape[inputShape.length - 1] = this.numTokens;
      return inputShape;
    }
  }, {
    key: "call",
    value: function call(inputs, kwargs) {
      var _this2 = this;
      return tidy(function () {
        inputs = getExactlyOneTensor(inputs);
        if (inputs.dtype !== 'int32') {
          inputs = K.cast(inputs, 'int32');
        }
        var countWeights;
        if (typeof kwargs['countWeights'] !== 'undefined') {
          if (_this2.outputMode !== 'count') {
            throw new ValueError("countWeights is not used when outputMode !== count.\n              Received countWeights=".concat(kwargs['countWeights']));
          }
          countWeights = getExactlyOneTensor(kwargs['countWeights']);
        }
        var maxValue = max(inputs);
        var minValue = min(inputs);
        var greaterEqualMax = greater(_this2.numTokens, maxValue).bufferSync().get(0);
        var greaterMin = greaterEqual(minValue, 0).bufferSync().get(0);
        if (!(greaterEqualMax && greaterMin)) {
          throw new ValueError('Input values must be between 0 < values <=' + " numTokens with numTokens=".concat(_this2.numTokens));
        }
        return utils.encodeCategoricalInputs(inputs, _this2.outputMode, _this2.numTokens, countWeights);
      });
    }
  }]);
  return CategoryEncoding;
}(Layer);
/** @nocollapse */
CategoryEncoding.className = 'CategoryEncoding';
export { CategoryEncoding };
serialization.registerClass(CategoryEncoding);